import { Chat } from "@/components/chat/chat";
import { DataStreamHandler } from "@/components/chat/data-stream-handler";

import { generateUUID } from "@/lib/utils";
import { ChatLayout } from "./chat_layout";
import { useSearchParams } from "react-router-dom";

export default function Page() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const chatType = type === 'dashboard' ? 'DASHBOARD' : undefined;
  const id = generateUUID();

  return (
    <ChatLayout>
      <Chat
        key={id}
        id={id}
        initialMessages={[]}
        selectedChatModel={"chat-model"}
        selectedVisibilityType="private"
        isReadonly={false}
        chatType={chatType}
      />
      <DataStreamHandler id={id} />
    </ChatLayout>
  );
}
